// CORE-1735 — Live icon v3 «trash» (remove from the session). Lid plus bin.
import React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Trash: React.FC<LiveGlyphProps> = ({ size, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Rect x={4} y={5.5} width={16} height={2.6} rx={1.3} fill={color} />
    <Path d="M9.5 3.2h5a1.2 1.2 0 0 1 1.2 1.2v1.1H8.3V4.4a1.2 1.2 0 0 1 1.2-1.2z" fill={color} />
    <Path d="M6 9.5h12l-.9 10.2a2 2 0 0 1-2 1.8H8.9a2 2 0 0 1-2-1.8z" fill={color} />
  </Svg>
);
